import { useGetAllTrainerList } from '../../assets/nodeApi/getApi/getHrApi'
import { useState } from 'react'
import { Button, Grid2, Typography } from '@mui/material'
import TableFilterTemplate from '../../shared/utils/TableFilterTemplate'
import { getFileUrl } from '../../shared/utils/getFileUrl'
import { useDialog } from '../../shared/hook/useDialog'
import MainDialogBox from '../../shared/components/Dialog/MainDialogBox'
import { Field, Form, Formik } from 'formik';
import * as Yup from 'yup';
import { TextFormField } from '../../shared/components/formfields/TextFormField'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useToaster } from '../../shared/utils/ToasterProvider'
import { putTermForTrainer } from '../../assets/nodeApi/putApi/putHrApi'
import { Grid_Gap } from '../../shared/constants'
import { useRadioGroup } from '../../shared/hook/useRadioGroup'
import { patchTrainerReject } from '../../assets/nodeApi/patchApi/patchHrApi'
import { AutoCompleteField } from '../../shared/components/formfields/AutoCompleteField'
import { useHrDropdownOptions } from './HrOption'
import { RadioButtonGroupFormField } from '../../shared/components/formfields/RadioButtonField'
import { CheckboxGroupFormField } from '../../shared/components/formfields/CheckboxGroupFormField'


const HrTrainerList = () => {
    const    queryClient=useQueryClient()
    const { trainerStatus } = useHrDropdownOptions()
    const { showToaster } = useToaster();
    const [selectedTrainer, setSelectedTrainer] = useState({})
    const [filters, setFilters] = useState({})
    const { open, handleClickOpen, handleClose } = useDialog();
    const { data: trainerList, isLoading: istrainerLoading } = useGetAllTrainerList(filters)
    const trainerOption =
        trainerList?.data?.map((item, index) => ({
            sr_no: index + 1,
            id: item?.id,
            ...item
        })) ?? [];
    const [rejectingId, setRejectingId] = useState(null);

    const mutationReject = useMutation({
        mutationFn: (id) => patchTrainerReject(id),
        onMutate: (id) => {
            setRejectingId(id);
        },
        onSuccess: (response) => {
            showToaster(response?.data?.message || 'Trainer rejected successfully', '', 'success');
            queryClient.invalidateQueries(['trainerUp/all']);
            setRejectingId(null);
        },
        onError: (err) => {
            showToaster(err?.response?.data?.error || 'Failed to reject trainer', '', 'error');
            setRejectingId(null);
        },
    });

    const trainerColumn = [
        {
            field: "sr_no",
            headerName: "Sr No",
            width: 100,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>

        },
        {
            field: "name",
            headerName: "Name",
            width: 180,
            renderCell: (params) => <Typography variant="body2">{params.row.firstname} {""} {params.row.lastname}</Typography>,
        },
        {
            field: "username",
            headerName: "User Name",
            width: 180,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "email",
            headerName: "Email",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },
        {
            field: "mobile",
            headerName: "Mobile Number",
            width: 200,
            renderCell: (params) => <Typography variant="body2">{params.value}</Typography>,
        },


        {
            field: "qualification",
            headerName: "Qualification",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params?.row?.user_resumes?.qualification}</Typography>,
        },
        {
            field: "preferred_location",
            headerName: "Location",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params?.row?.user_resumes?.preferred_location?.name}</Typography>,
        },
        {
            field: "preferred_subjects",
            headerName: "Subject",
            width: 150,
            renderCell: (params) => {
                const subjects = params?.row?.user_resumes?.preferred_subjects || [];

                return (
                    <Typography variant="body2">
                        {subjects.length ? `${subjects.join(", ")}.` : "-"}
                    </Typography>
                );
            },
        },
        {
            field: "preferred_zone",
            headerName: "Zone",
            width: 150,
            renderCell: (params) => <Typography variant="body2">{params?.row?.user_resumes?.preferred_zone?.name}</Typography>,
        },
        {
            field: "resume",
            headerName: "Resume",
            width: 200,
            renderCell: (params) => {
                const resumePath = params?.row?.user_resumes?.resume_path;

                if (!resumePath) {
                    return (
                        <Typography variant="body2">
                            No Resume
                        </Typography>
                    );
                }

                return (
                    <Button
                        variant="contained"
                        color="primary"
                        size="small"
                        onClick={() => {
                            const url = getFileUrl(resumePath);
                            window.open(url, "_blank");
                        }}
                    >
                        View Resume
                    </Button>
                );
            },
        },


        {
            field: "reject",
            headerName: "Reject",
            width: 120,
            renderCell: (params) => {
                const status = params?.row?.user_resumes?.status;
                const resumePath = params?.row?.user_resumes?.resume_path;
                // const isRejected = status === "HR Rejected";
                const isDisabled =
                    status !== "Created" || !resumePath || rejectingId === params?.row?.id;

                // if (isRejected) {
                //     return <Typography variant="body2">Rejected</Typography>;
                // }

                const isCurrentRejecting = rejectingId === params?.row?.id;

                return (
                    <Button
                        variant="contained"
                        color="error"
                        size="small"
                        disabled={isDisabled}
                        onClick={() => mutationReject.mutate(params?.row?.id)}
                    >
                        {isCurrentRejecting ? "Rejecting..." : "Reject"}
                    </Button>
                );
            },
        },

        {
            field: "accept",
            headerName: "Accept",
            width: 120,
            renderCell: (params) => {
                const status = params?.row?.user_resumes?.status;
                const resumePath = params?.row?.user_resumes?.resume_path;
                // const isAccepted = status === "Approved by HR";
                const isDisabled = status !== "Created" || !resumePath;

                // if (isAccepted) {
                //     return <Typography variant="body2">Accepted</Typography>;
                // }

                return (
                    <Button
                        variant="contained"
                        size="small"
                        disabled={isDisabled}
                        onClick={() => {
                            handleClickOpen();
                            setSelectedTrainer(params.row);
                        }}
                    >
                        Accept
                    </Button>
                );
            },
        },
        {
            field: "status",
            headerName: "Status",
            width: 200,
            renderCell: (params) => {


                return (
                    <Typography variant="body2">
                        {params?.row?.user_resumes?.status}
                    </Typography>
                );
            },
        },

    ];


    const classTypeOptions = [
        { id: 1, label: "Offline", value: "offline" },
        { id: 2, label: "Online", value: "online" },
        { id: 3, label: "Both", value: "both" },
    ];


    const mutation = useMutation({
        mutationFn: ({ payload, id }) => putTermForTrainer(payload, id),
    });

    const handleSubmit = (values, { resetForm }) => {
        if (!selectedTrainer?.id) {
            showToaster("No trainer selected!", "error");
            return;
        }
        const payload = {
            terms: {
                working_hours: values.working_hour,
                leave_policy: values.leave_policy,
                contract_duration: values.contract_duration,
                terms: values.terms,
                pay_type: values?.pay_type,
                working_days: values.working_days,
                leave_allotment: values.leave_allotment,
                class_type: values.class_type,
                days: values.days
            },
            monthly_salary: values.monthly_salary,
            per_hour: values.per_hour,
            per_class: values.per_class,
            bonus: values.bonus,

        };
        mutation.mutate(
            { payload, id: selectedTrainer.id },
            {
                onSuccess: () => {
                    queryClient.invalidateQueries({ queryKey: ["trainerUp/all"] });
                    showToaster('Terms Added Successfully', '', 'success');
                    resetForm();
                    handleClose();
                },
                onError: (err) => {
                    console.error(err);
                    showToaster("Error occurred while submitting terms.", "", "error");
                },
            }
        );
    };


    return (
        <>
            <TableFilterTemplate
                title="Resume Bank"
                columns={trainerColumn}
                rowsData={trainerOption || []}
                isLoading={istrainerLoading}
                filterInitialValues={filters}
                filterReset={() => setFilters({})}
                onApplyFilters={(f) => setFilters(f)}
                renderFilterFields={({ values }) => (
                    <>
                        <Grid2 children size={12}>
                            <Field
                                name="status"
                                component={AutoCompleteField}
                                options={trainerStatus.options}
                                label="Status"
                                maxDate={values?.to_date || undefined}

                            />
                        </Grid2>

                    </>
                )}
            />


            <MainDialogBox open={open} handleClose={handleClose} width={"60%"} heading={"Add Terms"}>
                <Formik
                    initialValues={{
                        working_hour: "",
                        leave_policy: "",
                        terms: "",
                        contract_duration: "",
                        monthly_salary: "",
                        per_hour: "",
                        per_class: "",
                        bonus: "",
                        pay_type: "",
                        working_days: "",
                        leave_allotment: ""
                        // reason: "",
                    }}
                    enableReinitialize={true}
                    validationSchema={Yup.object().shape({
                        working_hour: Yup.string().required("Required"),
                        leave_policy: Yup.string().required("Required"),
                        terms: Yup.string().required("Required"),
                        contract_duration: Yup.string().required("Required"),
                        // reason: Yup.string().required("Required"),
                        pay_type: Yup.string().required("Required"), // 👈 make radio required
                        monthly_salary: Yup.number().when("pay_type", {
                            is: "monthly",
                            then: (schema) => schema.required("Required"),
                        }),
                        working_days: Yup.number().when("pay_type", {
                            is: "monthly",
                            then: (schema) => schema.required("Required"),
                        }),
                        leave_allotment: Yup.number().when("pay_type", {
                            is: "monthly",
                            then: (schema) => schema.required("Required"),
                        }),
                        selectedDays: Yup.array().when("pay_type", {
                            is: "monthly",
                            then: (schema) =>
                                schema.min(1, "Please select at least one day."),
                            otherwise: (schema) => schema.notRequired(),
                        }),



                        per_hour: Yup.number().when("pay_type", {
                            is: "hourly",
                            then: (schema) => schema.required("Required"),
                        }),
                        per_class: Yup.number().when("pay_type", {
                            is: "perclass",
                            then: (schema) => schema.required("Required"),
                        }),
                    })}
                    onSubmit={handleSubmit}
                >
                    {({ values }) => (
                        <Form>
                            <Grid2 container spacing={Grid_Gap}>
                                <Grid2 children size={6}>
                                    <Field
                                        name="working_hour"
                                        component={TextFormField}
                                        label="Working Hour"
                                        isRequired
                                    />
                                </Grid2>

                                <Grid2 children size={6}>
                                    <Field
                                        name="leave_policy"
                                        component={TextFormField}
                                        label="Leave Policy"
                                        isRequired
                                    />
                                </Grid2>

                                <Grid2 children size={6}>
                                    <Field
                                        name="terms"
                                        component={TextFormField}
                                        label="Terms"
                                        isRequired
                                    />
                                </Grid2>

                                <Grid2 children size={6}>
                                    <Field
                                        name="contract_duration"
                                        component={TextFormField}
                                        label="Contract Duration"
                                        isRequired
                                    />
                                </Grid2>
                                <Grid2 children size={6}>
                                    <Field
                                        name="class_type"
                                        component={AutoCompleteField}
                                        options={classTypeOptions}
                                        label="Class Type"
                                        isRequired
                                    />
                                </Grid2>
                                <Field
                                    name="pay_type"
                                    component={RadioButtonGroupFormField}
                                    label="Salary Type"
                                    options={[
                                        { label: "Monthly Salary", value: "monthly" },
                                        { label: "Per Hour", value: "hourly" },
                                        { label: "Per Class", value: "perclass" },
                                    ]}
                                    row
                                    isRequired
                                />

                                {/* Show only the selected salary type */}
                                {values.pay_type === "monthly" && (
                                    <>
                                        <Grid2 children size={6}>
                                            <Field
                                                name="monthly_salary"
                                                component={TextFormField}
                                                label="Monthly Salary"
                                                isRequired
                                                type="number"
                                            />
                                        </Grid2>
                                        <Grid2 children size={6}>
                                            <Field
                                                name="working_days"
                                                component={TextFormField}
                                                label="Working Days in month"
                                                isRequired
                                                type="number"
                                            />
                                        </Grid2>
                                        <Field
                                            name="days"
                                            component={CheckboxGroupFormField}
                                            label="Select working days in week"
                                            options={[
                                                { label: "Monday", value: "monday" },
                                                { label: "Tuesday", value: "tuesday" },
                                                { label: "Wednesday", value: "wednesday" },
                                                { label: "Thursday", value: "thursday" },
                                                { label: "Friday", value: "friday" },
                                                { label: "Saturday", value: "saturday" },
                                                { label: "Sunday", value: "sunday" },
                                            ]}
                                        />

                                        <Grid2 children size={6}>
                                            <Field
                                                name="leave_allotment"
                                                component={TextFormField}
                                                label="Leave allotment"
                                                isRequired
                                                type="number"
                                            />
                                        </Grid2>
                                    </>
                                )}

                                {values.pay_type === "hourly" && (
                                    <Grid2 children size={6}>
                                        <Field
                                            name="per_hour"
                                            component={TextFormField}
                                            label="Per Hour"
                                            isRequired
                                            type="number"
                                        />
                                    </Grid2>
                                )}

                                {values.pay_type === "perclass" && (
                                    <Grid2 children size={6}>
                                        <Field
                                            name="per_class"
                                            component={TextFormField}
                                            label="Per Class"
                                            isRequired
                                            type="number"
                                        />
                                    </Grid2>
                                )}


                                <Grid2 children size={6}>
                                    <Field
                                        name="bonus"
                                        component={TextFormField}
                                        label="Bonus"
                                        type="number"
                                    />
                                </Grid2>

                                <Grid2 children textAlign="end" size={12}>
                                    <Button variant="contained" type="submit" fullWidth disabled={mutation.isPending}>
                                        {mutation.isPending ? "Submitting" : "Submit"}
                                    </Button>
                                </Grid2>
                            </Grid2>
                        </Form>
                    )}
                </Formik>

            </MainDialogBox>


        </>
    )
}

export default HrTrainerList
